import styled from 'styled-components';

export const Styled = styled.p<any>`
  font-size: 16px;
  line-height: 26px;
  color: ${(p) => p.color};

  a {
    color: #fa5245;
    text-decoration: underline;
    font-weight: 700;
  }
`;
